<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="500px"
    :mask-closable="false"
    :footer="null"
    class="qwdd-close-dialog"
    @cancel="TipDialogVisible=false"
  >
    <div
      class="dialog-tip-box dialog-tip-blue"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>{{ $t('message["404"]') }}</h2>
      <div class="d-tip-con">
        <p v-if="type === 'qw'">
          {{ $t('message["949"]') }}：<br>
          1. {{ $t('message["1086"]') }}」；<br>
          2. {{ $t('message["1538"]') }}；<br>
          3. {{ $t('message["538"]') }}<br>
          4. {{ $t('message["229"]') }}
        </p>
        <p v-if="type === 'dd'">
          {{ $t('message["948"]') }}：<br>
          1. {{ $t('message["1082"]') }}」<br>
          2. {{ $t('message["1540"]') }}」<br>
          3. {{ $t('message["495"]') }}
        </p>
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="TipDialogVisible=false"
        >
          {{ $t('message["1276"]') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false
    }
  },
  computed: {
  },
  methods: {
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    }
  }
}
</script>
<style lang="scss" scoped>
  .iconicon-test68 {
    color: #4494F0 !important;
  }
</style>
